module.exports = __webpack_public_path__ + "assets/img/5_1281.588099f2.jpg";